import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { movies } from "@/mocks/movies";

const styles = [
  { wrap: "bg-accent-950 border-accent-800/50", icon: "bg-accent-900/70 text-accent-200", count: "text-accent-300" },
  { wrap: "bg-primary-950 border-primary-900/60", icon: "bg-primary-900/60 text-primary-200", count: "text-primary-300" },
  { wrap: "bg-background-100 border-background-300/60", icon: "bg-background-200 text-foreground-700", count: "text-foreground-500" },
  { wrap: "bg-secondary-950 border-secondary-900/60", icon: "bg-secondary-900/60 text-secondary-200", count: "text-secondary-300" },
];

export default function CategoryQuickLinks() {
  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((category, index) => {
        const count = movies.filter((movie) => movie.genres.includes(category.key)).length;
        const style = styles[index % styles.length];
        return (
          <Link
            key={category.key}
            to={`/category/${category.key}`}
            className={`group flex items-center gap-4 rounded-lg border ${style.wrap} p-4 transition-colors hover:border-primary-500/70 md:p-5`}
          >
            <span className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-md ${style.icon}`}>
              <i className={`${category.icon} text-xl`}></i>
            </span>
            <span className="min-w-0 flex-1">
              <span className="flex items-baseline gap-2">
                <span className="font-heading text-base font-semibold text-foreground-900">{category.label}</span>
                <span className="font-label text-[10px] uppercase tracking-[0.18em] text-foreground-500">{category.en}</span>
              </span>
              <span className="mt-1 block truncate text-[12px] text-foreground-500">{category.tagline}</span>
            </span>
            <span className={`flex shrink-0 flex-col items-end font-label text-[11px] ${style.count}`}>
              <span className="text-base font-semibold">{String(count).padStart(2, "0")}</span>
              <span className="text-[10px] text-foreground-500">部作品</span>
            </span>
          </Link>
        );
      })}
    </div>
  );
}